import React, { useState } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIconButton,
  MotifIcon,
  MotifTextArea,
  MotifLabel,
  MotifFormField,
  MotifTextLink,
  MotifInput,
} from '@ey-xd/motif-react';
import {
  navigationIcClose24px,
  contentIcAddCircle24px,
  contentIcCreate24px,
} from '@ey-xd/motif-react/assets/icons';
import '../../organisms/modals/styles/judgeModelStyles.css';
import { useRecoilState } from 'recoil';
import {
  Active_Tab_Gcsp,
  All_Month_Data_State,
  Gcsp_Active_Tab_State,
  Gcsp_Opp_View_State,
  Recoil_Gcsp_Quarter_State,
  System_Date_Time_State,
} from '../../../recoil/recoil';
import { dateFormat, formateTOV } from '../../../util/commonUtil';

const JudgeModal = ({ KeyName }) => {
  const [isModalVisible, setModalVisibility] = useState(false);
  const [value, setValue] = useState('');
  const [submittedValue, setSubmittedValue] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Opp_View_State);
  const [Your_Total_Commit, setYour_Total_Commit] = useState('TBD');
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Gcsp_Quarter_State);
  const [activeTab, setActiveTab] = useRecoilState(Gcsp_Active_Tab_State);
  const [systemDateTime, setSystemDateTime] = useRecoilState(System_Date_Time_State);
  const [tabActive, setTabActive] = useRecoilState(Active_Tab_Gcsp);
  const [allMonthData, setAllMonthData] = useRecoilState(All_Month_Data_State);

  let PL_Committed_Value = 0;
  let Your_Judge = 0;
  if (
    allMonthData[tabActive].Total_Forecasted !== null &&
    allMonthData[tabActive].Your_Judge !== null &&
    allMonthData[tabActive].Total_Commit !== null
  ) {
    PL_Committed_Value = allMonthData[tabActive].Total_Forecasted.find(obj => KeyName in obj);
    PL_Committed_Value = PL_Committed_Value[KeyName];
    Your_Judge = allMonthData[tabActive].Your_Judge[0][KeyName];
  } else {
    PL_Committed_Value = gcspOppViewData.Total_Forecasted.find(obj => KeyName in obj);
    PL_Committed_Value = PL_Committed_Value[KeyName];
    Your_Judge = gcspOppViewData.Your_Judge[0][KeyName];
  }

  const personaStartDate = quarterData ? dateFormat(quarterData.persona_startdate) : '';
  const personaCloseDate = quarterData ? dateFormat(quarterData.persona_closedate) : '';
  const StartDate = quarterData ? dateFormat(quarterData.current_month_start_date) : '';
  const EndDate = quarterData ? dateFormat(quarterData.current_month_end_date) : '';
  const quarterStartDate = quarterData ? dateFormat(quarterData.quarter_start_date) : '';
  const quarterEndDate = quarterData ? dateFormat(quarterData.quarter_end_date) : '';

  let TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  let personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  let personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  let IsSubmitDisabled = false;

  IsSubmitDisabled = !(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck)
    ? true
    : false;

  const handleOpenModal = () => {
    if (value === '-') {
      setValue('');
    }

    if (!IsSubmitDisabled) {
      setModalVisibility(true);
      setIsEditMode(false);
    }
  };

  const handleSubmit = () => {
    // setSubmittedValue(value);
    judgeValueCalculation();
    setModalVisibility(false);
  };

  const handleEdit = () => {
    if (!IsSubmitDisabled) {
      setModalVisibility(true);
      setIsEditMode(true);
      setValue(Your_Judge);
      setYour_Total_Commit(Number(PL_Committed_Value) + Number(Your_Judge));
    }
  };

  const judgeValueCalculation = () => {
    if (gcspOppViewData.length !== 0) {
      let Total_Commit = allMonthData[tabActive].Total_Commit;
      let Your_Judge = allMonthData[tabActive].Your_Judge;
      if (Your_Total_Commit !== 'TBD') {
        Total_Commit = allMonthData[tabActive].Total_Commit.map(data => ({
          ...data,
          [KeyName]: Your_Total_Commit,
        }));
      }
      if (value !== '-') {
        Your_Judge = allMonthData[tabActive].Your_Judge.map(data => ({
          ...data,
          [KeyName]: Number(value),
        }));
      }

      setGcspOppViewData({
        ...gcspOppViewData,
        Total_Commit: Total_Commit,
        Your_Judge: Your_Judge,
      });

      setAllMonthData({
        ...allMonthData,
        [tabActive]: {
          ...allMonthData[tabActive],
          Total_Commit: Total_Commit,
          Your_Judge: Your_Judge,
        },
      });
    }
  };

  const handleKeyPress = event => {
    if (event.code === 'Enter') {
      toggleAccordion();
    }
  };

  return (
    <>
      {Your_Judge ? (
        <span
          style={{
            fontFamily: 'EYInterstate',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0px',
            color: '#2E2E38',
          }}
        >
          <MotifTextLink
            variant="alt"
            href="#"
            onClick={handleEdit}
            disabled={IsSubmitDisabled}
            aria-label={`Edit Your Judge ${Your_Judge}`}
          >
            <MotifIcon src={contentIcCreate24px} />
            <span aria-hidden="true"> {Your_Judge ? formateTOV(Your_Judge) : ''}</span>
          </MotifTextLink>
        </span>
      ) : (
        <MotifTextLink variant="alt" href="#" onClick={handleOpenModal} disabled={IsSubmitDisabled}>
          <MotifIcon src={contentIcAddCircle24px} />
          Add Judge
        </MotifTextLink>
      )}
      <MotifModal
        show={isModalVisible}
        variant="alt"
        onClose={() => setModalVisibility(false)}
        className="modal-container"
      >
        {/* <MotifModalHeader>
          {isEditMode ? 'Add Judge: Assurance' : 'Add Judge: Assurance'}
        </MotifModalHeader> */}
        <MotifModalHeader
          className="modal-header"
          closeModalButton={
            <MotifIconButton
              type="button"
              onClick={() => setModalVisibility(false)}
              className="motif-modal--header-icon-button"
              title="Click here to close modal"
            >
              <MotifIcon src={navigationIcClose24px} />
            </MotifIconButton>
          }
        >
          {KeyName.toLowerCase() === 'assurance'
            ? 'Judge Value: Assurance'
            : KeyName.toLowerCase() === 'consulting'
              ? 'Judge Value: Consulting'
              : KeyName.toLowerCase() === 'sat'
                ? 'Judge Value: SAT'
                : KeyName.toLowerCase() === 'tax'
                  ? 'Judge Value: Tax'
                  : KeyName.toLowerCase() === 'itts'
                    ? 'Judge Value: ITTS'
                    : KeyName.toLowerCase() === 'emiaacr'
                      ? 'Judge Value: EMEIA ACR'
                      : ''}
        </MotifModalHeader>
        <MotifModalBody className="custom-modal-body">
          <div className="row-layout">
            <div className="table-data1">
              <div className="text-value1">PL Committed Value</div>
            </div>
            <div className="table-data2">
              <div className="text-value2">
                {PL_Committed_Value ? formateTOV(PL_Committed_Value) : '$0'}
              </div>
            </div>
          </div>
          <div className="row-layout">
            <div className="table-data1">
              <div className="text-value1">Your Judge</div>
            </div>
            <MotifFormField className="input-area">
              {value === '' && <MotifLabel className="text-label">Add Judge</MotifLabel>}
              <MotifInput
                className="input-value"
                value={value}
                onChange={event => {
                  const inputValue = event.target.value;
                  const minAllowedValue = -1 * PL_Committed_Value;
                  // Allow input if it's empty, a valid number, within the allowed range, and the length is less than or equal to 12 digits
                  if (
                    (/^-?\d{0,12}$/.test(inputValue) && +inputValue >= minAllowedValue) ||
                    inputValue === '-'
                  ) {
                    // If inputValue is just '-', set it to 0 when updating setYour_Total_Commit
                    const numericInputValue = inputValue === '-' ? 0 : +inputValue;
                    setValue(inputValue);
                    const newTotalCommit = Number(PL_Committed_Value) + Number(numericInputValue);
                    setYour_Total_Commit(newTotalCommit);
                    setSubmittedValue(numericInputValue);
                  }
                }}
                required={true} // Add the required attribute
              />
            </MotifFormField>
          </div>
          <div className="row-layout">
            <div className="table-data1">
              <div className="text-value1">Your Total Commit</div>
            </div>
            <div className="table-data2">
              <div className="text-value2">
                {Your_Total_Commit !== 'TBD' ? formateTOV(Your_Total_Commit) : '$0'}
              </div>
            </div>
          </div>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton type="button" onClick={handleSubmit}>
            Save
          </MotifButton>
          <MotifButton variant="secondary" type="button" onClick={() => setModalVisibility(false)}>
            Cancel
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
};

export default JudgeModal;
